import { setHero, toHub } from "../app.ts";
import { bird } from "../data/story.ts";
import { now, setScene } from "../engine.ts";
import { Actor } from "../render/actor.ts";
import { drawArena, GROUND } from "../render/arena.ts";
import { Fx } from "../render/fx.ts";
import { clearSave, loadHero } from "../save.ts";
import { btn, h, mount } from "../ui/dom.ts";
import { muteButton, showHelp } from "./common.ts";
import { creatorScreen } from "./creator.ts";

export function titleScreen(): void {
  const saved = loadHero();
  const champ = new Actor(
    saved?.look ?? bird({ tailStyle: "sickle", extra: "bandana", eyes: "fierce", tail: "#2b2b33", size: 1.05 }),
    { weapon: "eggscalibur", helmet: "crown", armor: "regalia", boots: "wingedtalons" },
    1,
    330,
  );
  champ.state = "victory";
  const fx = new Fx();
  let nextFeathers = 0;

  setScene((ctx, t, dt) => {
    drawArena(ctx, "colosseum", t, 0.9);
    champ.draw(ctx, t, GROUND + 10, 2.5);
    if (t > nextFeathers) {
      nextFeathers = t + 0.35;
      fx.feathers(Math.random() * 1280, -20, ["#f5c431", "#ffffff", "#c62f24"][Math.floor(Math.random() * 3)] ?? "#fff", 1);
    }
    fx.draw(ctx, t, dt);
  });

  const start = () => {
    if (saved && !confirm("Start over? Your current champion will be lost.")) return;
    clearSave();
    creatorScreen({ mode: "new" });
  };

  mount(
    (e) => {
      if (e.key === "Enter") saved ? (setHero(saved), toHub()) : start();
    },
    h("div", { class: "title-logo" }, h("h1", null, "Coop d'État"), h("div", { class: "tag" }, "One chicken. One arena. Total world domination.")),
    h(
      "div",
      { class: "title-menu" },
      saved &&
        btn(["Continue", h("span", { class: "sub" }, `${saved.name} · Level ${saved.level}`)], () => {
          setHero(saved);
          toHub();
        }, "green big pulse"),
      btn(saved ? "New Game" : "Hatch a Champion", start, saved ? "" : "green big pulse"),
      btn("How to Play", showHelp, "wood"),
    ),
    muteButton(),
    h("div", { class: "credit" }, "A gladiator saga for chickens with ambition."),
  );
  void champ.play("taunt", now());
}
